import Index from "views/Index.js";
import Profile from "views/auth/Profile.js";
import Login from "views/auth/Login.js";
import ForgotPassword from "views/auth/ForgotPassword.js";
import VerifyOtp from "views/auth/VerifyOtp";
import SetNewPassword from "views/auth/SetNewPassword";
import Verify2FAOtp from "views/auth/Verify2FAOtp";
import UserTable from "views/users/UserTable";
import TourPackages from "views/categories/categories";
import PrivacyPolicy from "views/management/PrivacyPolicy";
import TermsConditions from "views/management/TermsConditions";
import ContactUs from "views/management/ContactUs";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa";
import Membership from "views/membership/membership.js";
import Reviews from "views/review&rating/review";
import TourPackage from "views/tourmanagement/tourpackages";
import FaqManagement from "views/faq/faqmanagement";
import GuideBookingManagement from "views/booking-management/GuideBookingManagement";
import GuideManagement from "views/guide-management/GuideManagement";
import RoleManagement from "views/role/RoleManagement";
import PopularDestinations from "views/destinations/PopularDestinations";

// Localmate Sidebar Modules
import SafetyVerification from "views/safety/SafetyVerification";
import PaymentsRevenue from "views/payments/PaymentsRevenue";
import ContentManagement from "views/content/ContentManagement";
import SupportReports from "views/support/SupportReports";
import AnalyticsManagement from "views/analytics/AnalyticsManagement";
import Report from "views/report/Report";

import {
  UserIcon,
  DocumentIcon,
  AgreementIcon,
  PhoneIcon,
} from "components/Icons";
import { FiCompass, FiCheckCircle } from "react-icons/fi";
import { LuUsers } from "react-icons/lu";
import {
  FaCrown,
  FaStar,
  FaAward,
  FaQuestionCircle,
  FaCalendarCheck,
  FaShieldAlt,
  FaMoneyBillWave,
  FaGlobeAmericas,
  FaSlidersH,
  FaHeadset,
  FaChartLine,
  FaFileAlt,
} from "react-icons/fa";

var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: <MdOutlineDashboardCustomize className="min-w-24 min-h-24" />,
    component: <Index />,
    layout: "/admin",
  },
  {
    path: "/users-list",
    name: "User Management",
    icon: <LuUsers className="min-w-24 min-h-24" />,
    component: <UserTable />,
    layout: "/admin",
  },
  {
    path: "/verification-management",
    name: "Verification Management",
    icon: <FiCompass className="min-w-24 min-h-24" />,
    component: <GuideManagement />,
    layout: "/admin",
  },
  {
    path: "/guide-management",
    component: <GuideManagement />,
    layout: "/admin",
  },
  {
    path: "/guide-bookings",
    name: "Booking Management",
    icon: <FaCalendarCheck className="min-w-24 min-h-24" />,
    component: <GuideBookingManagement />,
    layout: "/admin",
  },
  {
    path: "/reviews",
    name: "Reviews & Ratings",
    icon: <FaStar className="min-w-24 min-h-24" />,
    component: <Reviews />,
    layout: "/admin",
  },
  {
    path: "/safety-verification",
    name: "Safety & Verification",
    icon: <FaShieldAlt className="min-w-24 min-h-24" />,
    component: <SafetyVerification />,
    layout: "/admin",
  },
  {
    path: "/payments-revenue",
    name: "Payments & Revenue",
    icon: <FaMoneyBillWave className="min-w-24 min-h-24" />,
    component: <PaymentsRevenue />,
    layout: "/admin",
  },

  {
    path: "/content-management",
    name: "Content Management",
    icon: <FaSlidersH className="min-w-24 min-h-24" />,
    component: <ContentManagement />,
    layout: "/admin",
  },
  {
    path: "/help-support",
    name: "Help & Support",
    icon: <FaHeadset className="min-w-24 min-h-24" />,
    component: <SupportReports />,
    layout: "/admin",
  },
  {
    path: "/support-reports",
    component: <SupportReports />,
    layout: "/admin",
  },
  {
    path: "/report",
    name: "Report Management",
    icon: <FaFileAlt className="min-w-24 min-h-24" />,
    component: <Report />,
    layout: "/admin",
  },
  {
    path: "/reports",
    component: <Report />,
    layout: "/admin",
  },
  {
    path: "/analytics",
    name: "Analytics",
    icon: <FaChartLine className="min-w-24 min-h-24" />,
    component: <AnalyticsManagement />,
    layout: "/admin",
  },
  {
    path: "/membership",
    name: "Membership Management",
    icon: <FaAward className="min-w-24 min-h-24" />,
    component: <Membership />,
    layout: "/admin",
  },
  {
    path: "/tour-package",
    name: "Tour Package Management",
    icon: <FiCheckCircle className="min-w-24 min-h-24" />,
    component: <TourPackage />,
    layout: "/admin",
  },
  {
    path: "/destinations",
    name: "Popular Destinations",
    icon: <FaGlobeAmericas className="min-w-24 min-h-24" />,
    component: <PopularDestinations />,
    layout: "/admin",
  },
  {
    path: "/popular-destinations",
    component: <PopularDestinations />,
    layout: "/admin",
  },
  {
    path: "/categories",
    name: "Tour Categories Management",
    icon: <FaLayerGroup className="min-w-24 min-h-24 button-secondary-color !mr-0" />,
    component: <TourPackages />,
    layout: "/admin",
  },
  {
    path: "/faq",
    name: "FAQ Management",
    icon: <FaQuestionCircle className="min-w-24 min-h-24 button-secondary-color !mr-0" />,
    component: <FaqManagement />,
    layout: "/admin",
  },
  {
    path: "/role-management",
    name: "Role Management",
    icon: <FaShieldAlt className="min-w-24 min-h-24 button-secondary-color !mr-0" />,
    component: <RoleManagement />,
    layout: "/admin",
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    icon: <DocumentIcon className="min-w-24 min-h-24" />,
    component: <PrivacyPolicy />,
    layout: "/admin",
  },
  {
    path: "/terms-conditions",
    name: "Terms & Conditions",
    icon: <AgreementIcon className="min-w-24 min-h-24" />,
    component: <TermsConditions />,
    layout: "/admin",
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    icon: <PhoneIcon className="min-w-24 min-h-24" />,
    component: <ContactUs />,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "Profile",
    icon: <UserIcon className="min-w-24 min-h-24" />,
    component: <Profile />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-lock-circle-open text-warning",
    component: <ForgotPassword />,
    layout: "/auth",
  },
  {
    path: "/verify-otp",
    name: "Verify OTP",
    icon: "ni ni-lock-circle-open text-warning",
    component: <VerifyOtp />,
    layout: "/auth",
  },
  {
    path: "/set-new-password",
    name: "Set new password",
    icon: "ni ni-lock-circle-open text-warning",
    component: <SetNewPassword />,
    layout: "/auth",
  },
  {
    path: "/verify-2fa-otp",
    name: "Verify 2FA",
    icon: "ni ni-lock-circle-open text-info",
    component: <Verify2FAOtp />,
    layout: "/auth",
  },
];

export default routes;
